import { create } from 'zustand';
import { ProducerLocation } from '../../types';

interface ProducerLocationsState {
	producerLocations: ProducerLocation[] | null;
	setProducerLocations: (producerLocations: ProducerLocation[]) => void;
	producerLocationsLoaded: boolean;
	setProducerLocationsLoaded: (loaded: boolean) => void;
}

const useProducerLocations = create<ProducerLocationsState>((set) => ({
	producerLocations: null,
	setProducerLocations: (producerLocations: ProducerLocation[]) => set({ producerLocations }),
	producerLocationsLoaded: false,
	setProducerLocationsLoaded: (loaded: boolean) => set({ producerLocationsLoaded: loaded }),
}));

export default useProducerLocations;
